// "Descartar o pedido?" ao sair do Novo Pedido com produtos no carrinho
// (30/09/2026). Antes a seta ← descartava na hora, inclusive os produtos que
// vieram do Balcão pela "Entrega".
import {
  AlertDialog,
  AlertDialogAction,
  AlertDialogCancel,
  AlertDialogContent,
  AlertDialogDescription,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogTitle,
} from "../../components/ui/alert-dialog";

export default function ConfirmarDescarte({ open, onOpenChange, onDescartar }) {
  return (
    <AlertDialog open={open} onOpenChange={onOpenChange}>
      <AlertDialogContent data-e2e="np-confirmar-descarte">
        <AlertDialogHeader>
          <AlertDialogTitle>Descartar o pedido?</AlertDialogTitle>
          <AlertDialogDescription>
            Os produtos do carrinho, o cliente e o endereço escolhidos saem da tela. O pedido não é criado.
          </AlertDialogDescription>
        </AlertDialogHeader>
        <AlertDialogFooter>
          <AlertDialogCancel>Continuar o pedido</AlertDialogCancel>
          <AlertDialogAction className="bg-red-600 hover:bg-red-700" onClick={onDescartar}>
            Descartar
          </AlertDialogAction>
        </AlertDialogFooter>
      </AlertDialogContent>
    </AlertDialog>
  );
}
